import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-edit-query',
  templateUrl: './edit-query.component.html',
  styleUrls: ['./edit-query.component.scss']
})

export class EditQueryComponent implements OnInit {
  editQuery: FormGroup;
  jobStages: { stageName, value }[] = [
    { stageName: "Job Init", value: 0 },
    { stageName: "Data Copy", value: 1 },
    { stageName: "Job Submit", value: 2 },
    { stageName: "Job Execute", value: 3 },
  ]

  jobOperationalStatus: { operationalStatus, value }[] = [
    { operationalStatus: "Cancelled", value: 1 },
    { operationalStatus: "Failed", value: 5 },
    { operationalStatus: "Queued", value: 9 },
    { operationalStatus: "Running", value: 10 },
    { operationalStatus: "Succeeded", value: 11 },
    { operationalStatus: "Wait", value: 13 },
  ]
  jobsQueryFields: { name, selected, value }[] = [
    {
      name: "Global State",
      selected: false,
      value: "GlobalState"
    },
    {
      name: "Job Stage",
      selected: false,
      value: "JobStage"
    },
    {
      name: "Job Stage Status",
      selected: false,
      value: "JobStageStatus"
    },
    {
      name: "Application",
      selected: false,
      value: "JobApplication"
    },
    {
      name: "User",
      selected: false,
      value: "UserProfileId"
    },
    {
      name: "Cores",
      selected: false,
      value: "JobCores"
    },
    {
      name: "Allocated Nodes",
      selected: false,
      value: "JobAllocatedNodes"
    }
  ]
  finalQuery: {} = {
    select: [],
    from: "JobInfoes",
    where: {}
  };

  constructor(
    public dialog: MatDialogRef<EditQueryComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depname: string,
      userName: string,
      userRole: string,
      filterUser: string,
      filterStatus: string,
      filterApplication: string,
      isQueryActive: boolean,
        queryString: string
      }
  ) { }

  ngOnInit(): void {
    this.editQuery = new FormGroup({
      whereClause: new FormArray([])
    })
    this.queryInitialization()
  }

 queryInitialization() {
    const control = this.editQuery.get('whereClause') as FormArray;
    if (this.data.isQueryActive) {
      if (this.data.queryString) {
        let queryObject = JSON.parse(JSON.stringify(this.data.queryString));
        Object.entries(queryObject.where).forEach(([key, value]) => {
          let entriesArray
          const fieldName = key
          if (key == "JobAllocatedNodes") {
            entriesArray = value;
          } else {
            entriesArray = JSON.parse(JSON.stringify(value)).join(",")
          }
          if (fieldName == 'JobStageStatus' || fieldName == 'JobStage') {
            if (fieldName == "JobStage") {
              entriesArray = this.getJobStageNames(value);
            } else {
              entriesArray = this.getJobStageStatusNames(value);
            }
          }
          control.push(
            new FormGroup({
              type: new FormControl(fieldName, [Validators.required]),
              entry: new FormControl(entriesArray, [Validators.required])
            })
          )
        });

        // Handle "All" filters that were stored separately
        if (queryObject.allFilters) {
          Object.entries(queryObject.allFilters).forEach(([key, value]) => {
            control.push(
              new FormGroup({
                type: new FormControl(key, [Validators.required]),
                entry: new FormControl(value, [Validators.required])
              })
            )
          });
        }
      }
    }
    else {
      const initialFileds = [
        new FormGroup({
          type: new FormControl('UserProfileId', [Validators.required]),
          entry: new FormControl(this.data.filterUser ? this.data.filterUser : this.data.userName, [Validators.required])
        }),
        new FormGroup({
          type: new FormControl('JobApplication', [Validators.required]),
          entry: new FormControl(this.data.filterApplication ? this.data.filterApplication : "", [Validators.required])
        }),
        new FormGroup({
          type: new FormControl('JobStageStatus', [Validators.required]),
          entry: new FormControl(this.data.filterStatus ? this.data.filterStatus : "", [Validators.required])
        })
      ]
      for (let i = 0; i < 3; i++) {
        control.push(initialFileds[i])
      }
    }
  }

  onSubmit() {
    if (this.editQuery.status === "INVALID") {
      this.editQuery.markAllAsTouched();
      return
    }
    let query = this.construtQueryString(this.editQuery.value)
    this.dialog.close({ status: true, query: query });
  }

  onClose() {
    this.dialog.close(false)
  }

  addNewWhereCondition() {
    const control = this.editQuery.get('whereClause') as FormArray;
    control.push(
      new FormGroup({
        type: new FormControl('', [Validators.required]),
        entry: new FormControl('', [Validators.required])
      })
    )
  }

  removeQuery(index) {
    const control = this.editQuery.get('whereClause') as FormArray;
    if (control.length == 1) {
      this.snackBar.open("Please provide query", 'Ok', {
        duration: 5000,
      });
      return
    }
    control.removeAt(index)
  }

  construtQueryString(queryObj) {
    let query = queryObj.whereClause;
    let resObj = {}
    let allFiltersObj = {} // Store "All" filters separately

    query.forEach(el => {
      if (resObj[el.type]) {
        resObj[el.type] = `${el.entry}`;
      } else {
        // Store "All" filters separately to preserve them for UI
        if (el.entry === "All") {
          allFiltersObj[el.type] = el.entry;
        } else {
          // Handle non-"All" filters as before
          if (el.type == "GlobalState") {
            resObj[el.type] = this.getGlobalStateValues(el.entry);
          }
          else if (el.type == "JobStage") {
            resObj[el.type] = this.getJobStageValues(el.entry);
          } else if (el.type == "JobStageStatus") {
            resObj[el.type] = this.getJobStageStatusValues(el.entry);
          } else if (el.type == "JobAllocatedNodes") {
            if (el.entry.includes(",")) {
              resObj[el.type] = el.entry.split(",").map(el => el.trim()).join(",")
            } else if (el.entry.includes("&")) {
              resObj[el.type] = el.entry.split("&").map(el => el.trim()).join("&")
            } else {
              resObj[el.type] = el.entry.split(",").map(el => el.trim()).join(",");
            }
          } else {
            resObj[el.type] = el.entry.split(",").map(el => el.trim());
          }
        }
      }
    })

    this.finalQuery['where'] = { ...resObj };
    this.finalQuery['orderBy'] = "CreateTime DESC";

    // Store "All" filters separately to preserve UI state
    if (Object.keys(allFiltersObj).length > 0) {
      this.finalQuery['allFilters'] = allFiltersObj;
    }

    return this.finalQuery;
  }

  getJobQueryFields() {
    return this.jobsQueryFields.filter((el: any) => !el.selected)
  }

  changeChanged(val) {
    const control = this.editQuery.get('whereClause') as FormArray;
  }

  getGlobalStateValues(entries: string){
    let check = entries.split(",");
    let globalStateValue = check.map(el => {
      let val = el.trim().toLowerCase();
      if(val === "delete" || val === "deleted"){
        return "Delete";
      }
      else if(val === "active"){
        return "Active";
      }
      else if(val === "inactive"){
        return "Inactive";
      }
    });

    return globalStateValue && globalStateValue.length != 0 ? globalStateValue : [];
  }

  getJobStageValues(entries: string) {
    let jobStageName = entries.split(",").map(el => el.trim());
    let jobStageValue = jobStageName.map(el => {
      let res = this.jobStages.find(ele => ele.stageName.toLowerCase() == el.trim().toLowerCase())
      if (res) {
        return res.value
      }
    })
    return jobStageValue && jobStageValue.length != 0 ? jobStageValue : [];
  }

  getJobStageNames(values) {
    let jobStageValueArray = JSON.parse(JSON.stringify(values));
    let jobStageNames = jobStageValueArray.map(el => {
      let res = this.jobStages.find(ele => ele.value == Number(el))
      if (res) {
        return res.stageName
      }
    })
    return jobStageNames && jobStageNames.length != 0 ? jobStageNames.join(",") : "";
  }

  getJobStageStatusValues(entries: string) {
    let jobStageStatusName = entries.split(",").map(el => el.trim());
    let jobStageValue = jobStageStatusName.map(el => {
      let res = this.jobOperationalStatus.find(ele => ele.operationalStatus.toLowerCase() == el.trim().toLowerCase())
      if (res) {
        return res.value
      }
    })
    return jobStageValue && jobStageValue.length != 0 ? jobStageValue : [];
  }

  getJobStageStatusNames(values) {
    let jobStageStatusValueArray = JSON.parse(JSON.stringify(values));
    let operationalStatusNames = jobStageStatusValueArray.map(el => {
      let res = this.jobOperationalStatus.find(ele => ele.value == el)
      if (res) {
        return res.operationalStatus
      }
    })
    return operationalStatusNames && operationalStatusNames.length != 0 ? operationalStatusNames.join(",") : "";
  }

  resetFilters() {
    // Clear the current form array
    const control = this.editQuery.get('whereClause') as FormArray;
    while (control.length !== 0) {
      control.removeAt(0);
    }

    // Reset to initial default filters
    const initialFileds = [
      new FormGroup({
        type: new FormControl('UserProfileId', [Validators.required]),
        entry: new FormControl(this.data.filterUser ? this.data.filterUser : this.data.userName, [Validators.required])
      }),
      new FormGroup({
        type: new FormControl('JobApplication', [Validators.required]),
        entry: new FormControl(this.data.filterApplication ? this.data.filterApplication : "", [Validators.required])
      }),
      new FormGroup({
        type: new FormControl('JobStageStatus', [Validators.required]),
        entry: new FormControl(this.data.filterStatus ? this.data.filterStatus : "", [Validators.required])
      })
    ];

    // Add the initial filters back
    for (let i = 0; i < 3; i++) {
      control.push(initialFileds[i]);
    }

    // Mark form as untouched to clear any validation errors
    this.editQuery.markAsUntouched();
    this.onSubmit();
  }

}
